export const WHATSAPP_DISPLAY = "+55 75 98331-4111";
export const WHATSAPP_RAW = "5575983314111";
export const DEFAULT_MSG =
  "Olá! Gostaria de assinar a Flash Play TV e ativar meu acesso.";

export const TRIAL_MSG =
  "Olá! Quero o TESTE GRÁTIS de 12 horas da Flash Play TV!";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_RAW}?text=${encodeURIComponent(msg)}`;

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -108 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1618193139062-2c5bf4f935b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxob21lJTIwdGhlYXRlciUyMHR2JTIwc2NyZWVuJTIwc3RyZWFtaW5nJTIwZGFyayUyMHJvb218ZW58MHx8fHwxNzg5MTk1MDExfDA&ixlib=rb-4.1.0&q=85",
  stadium:
    "https://images.unsplash.com/photo-1515100235140-6cb3498e8031?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjBzdGFkaXVtJTIwY3Jvd2QlMjBkYXJrJTIwYnJvYWRjYXN0fGVufDB8fHxibHVlfDE3OTE2NDAxMTh8MA&ixlib=rb-4.1.0&q=85",
  remote:
    "https://images.unsplash.com/photo-1730830741396-ffb85bb2e983?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxob21lJTIwdGhlYXRlciUyMHR2JTIwc2NyZWVuJTIwc3RyZWFtaW5nJTIwZGFyayUyMHJvb218ZW58MHx8fHwxNzg5MTk1MDExfDA&ixlib=rb-4.1.0&q=85",
};

export const marqueeItems = [
  "Canais em 4K UHD",
  "Futebol ao vivo",
  "Filmes e séries todo dia",
  "Sem travamentos",
  "Suporte VIP no WhatsApp",
  "Ativação imediata",
];

export const plans = [
  {
    id: "mensal",
    name: "Plano Mensal",
    duration: "1 mês",
    price: "R$ 30,00",
    billing: "/mês",
    equivalent: null,
    badge: null,
    highlight: false,
    features: [
      "Canais, filmes e séries liberados",
      "Qualidade 4K UHD / Full HD",
      "Zero travamento — servidor dedicado",
      "Suporte VIP no WhatsApp 24/7",
      "1 conexão simultânea",
    ],
    msg: "Olá! Quero contratar o Plano MENSAL por R$ 30,00.",
  },
  {
    id: "trimestral",
    name: "Plano Trimestral",
    duration: "3 meses",
    price: "R$ 85,00",
    billing: "/3 meses",
    equivalent: "R$ 28,33/mês",
    badge: "Economize R$ 5,00",
    highlight: false,
    features: [
      "Canais, filmes e séries liberados",
      "Qualidade 4K UHD / Full HD",
      "Zero travamento — servidor dedicado",
      "Suporte VIP no WhatsApp 24/7",
      "Guia de programação (EPG)",
      "1 conexão simultânea",
    ],
    msg: "Olá! Quero contratar o Plano TRIMESTRAL por R$ 85,00.",
  },
  {
    id: "semestral",
    name: "Plano Semestral",
    duration: "6 meses",
    price: "R$ 160,00",
    billing: "/6 meses",
    equivalent: "R$ 26,67/mês",
    badge: "Economize R$ 20,00",
    highlight: false,
    features: [
      "Canais, filmes e séries liberados",
      "Qualidade 4K UHD / Full HD",
      "Zero travamento — servidor dedicado",
      "Suporte VIP no WhatsApp 24/7",
      "EPG + Playback de 7 dias",
      "2 conexões simultâneas",
    ],
    msg: "Olá! Quero contratar o Plano SEMESTRAL por R$ 160,00.",
  },
  {
    id: "anual",
    name: "Plano Anual",
    duration: "12 meses",
    price: "R$ 240,00",
    billing: "/ano",
    equivalent: "Apenas R$ 20,00/mês",
    badge: "Melhor custo-benefício",
    highlight: true,
    features: [
      "Tudo liberado: canais, filmes e séries",
      "4K Ultra HD e 60FPS nos esportes",
      "Servidores anti-buffering de alta velocidade",
      "Suporte prioritário VIP 24/7",
      "Compatível com todos os dispositivos",
      "Ativação imediata após confirmação",
      "2 conexões simultâneas incluídas",
    ],
    msg: "Olá! Quero aproveitar o Plano ANUAL (12 meses) por R$ 240,00 — o melhor custo-benefício!",
  },
];

export const testimonials = [
  {
    id: 0,
    quote:
      "Assisto o futebol todo domingo sem travar nenhuma vez. A qualidade 4K impressionou todo mundo aqui em casa.",
    label: "Cliente • Smart TV",
  },
  {
    id: 1,
    quote:
      "Atendimento rápido de verdade: chamei no WhatsApp e em minutos já estava tudo funcionando na minha TV.",
    label: "Cliente • Fire Stick",
  },
  {
    id: 2,
    quote:
      "Peguei o teste grátis de 12 horas, gostei e fechei o plano anual. Melhor custo-benefício que encontrei.",
    label: "Cliente • Plano Anual",
  },
];

export const faqs = [
  {
    q: "Como faço para assinar um plano?",
    a: "É simples: escolha o plano acima e clique em “Assinar pelo WhatsApp”. Nossa equipe responde na hora, confirma seus dados e recebe o pagamento — tudo direto no WhatsApp.",
  },
  {
    q: "Em quanto tempo meu acesso é ativado?",
    a: "A ativação é imediata: assim que o pagamento é confirmado, enviamos suas credenciais e você já pode assistir.",
  },
  {
    q: "Funciona no meu aparelho?",
    a: "Sim! A Flash Play TV funciona em Smart TV (Samsung, LG, Android TV), celular, tablet, TV Box, Fire TV Stick e computador.",
  },
  {
    q: "Que tipo de internet eu preciso?",
    a: "Recomendamos no mínimo 10 Mbps para aproveitar o 4K. Com uma internet comum você assiste muito bem em Full HD, sempre sem travamentos.",
  },
  {
    q: "Posso testar antes de comprar?",
    a: "Claro! Todo cliente novo pode pedir o teste 100% gratuito de 12 horas: chame a gente no WhatsApp, ative agora e conheça a qualidade antes de assinar qualquer plano.",
  },
];
